module.exports = __webpack_public_path__ + "img/xiaozhuzi.4e84ad2a.png";